<template>
    <div style="min-height: 550px">
        <div class="md-layout md-alignment-bottom-right">
            <div class="md-layout-item md-size-45">
                <vue-ctk-date-time-picker
                    :auto-close="false"
                    :disabled="fetching"
                    @validate="fetchData"
                    :label="$t('fecha')"
                    minute-interval="60"
                    v-model="selectedDate"
                    formatted="YYYY-MM-DD HH:mm"
                    format="YYYY-MM-DD HH:mm"
                >
                </vue-ctk-date-time-picker>
            </div>
        </div>
        <div>
            <line-chart
                v-if="loaded"
                :width="800"
                :height="400"
                :chart-data="datacollection"
                :options="options"
            ></line-chart>
        </div>
    </div>
</template>

<script>
let BACKEND_API = process.env.VUE_APP_BACKEND_API;
import { authHeader } from "../../helpers/auth-header";
import { handleResponse } from "../../helpers/handle-response";
import "@lazy-copilot/datetimepicker/dist/datetimepicker.css";
import LineChart from "./LineChart";

export default {
    name: "advanced_chart",
    components: { LineChart },
    props: ["paciente"],
    mounted() {
        this.fetchData();
    },
    data() {
        return {
            fetching: false,
            loaded: false,
            selectedDate: this.$moment(new Date()).format("YYYY-MM-DD HH:mm"),
            datacollection: {
                labels: [],
                datasets: [],
            },
            options: {
                maintainAspectRatio: true,
                elements: {
                    line: {
                        tension: 0,
                    },
                    point: {
                        radius: 0,
                    },
                },
                tooltips: {
                    position: "nearest",
                    mode: "index",
                    intersect: false,
                },
                scales: {
                    xAxes: [
                        {
                            type: "time",
                            time: {
                                displayFormats: {
                                    minute: "H:mm",
                                },
                            },
                        },
                    ],
                    yAxes: [
                        {
                            display: true,
                            ticks: {
                                suggestedMax: 100,
                                suggestedMin: 0,
                                beginAtZero: true,
                            },
                        },
                    ],
                },
                annotation: {
                    annotations: [
                        {
                            drawTime: "afterDatasetsDraw",
                            type: "line",
                            mode: "horizontal",
                            scaleID: "y-axis-0",
                            value: 0,
                            borderColor: "#9fa8da",
                            borderWidth: 2,
                            label: {
                                position: "center",
                                yAdjust: -15,
                                backgroundColor: "#9fa8da",
                                content: this.$t("dry"),
                                enabled: true,
                            },
                        },
                        {
                            drawTime: "afterDatasetsDraw",
                            type: "line",
                            mode: "horizontal",
                            scaleID: "y-axis-0",
                            value: 33,
                            borderColor: "#FFE449",
                            borderWidth: 2,
                            label: {
                                backgroundColor: "#FFE449",
                                content: this.$t("level1"),
                                enabled: true,
                            },
                        },
                        {
                            drawTime: "afterDatasetsDraw",
                            type: "line",
                            mode: "horizontal",
                            scaleID: "y-axis-0",
                            value: 59,
                            borderColor: "#ffa500",
                            borderWidth: 2,
                            label: {
                                backgroundColor: "#ffa500",
                                content: this.$t("level2"),
                                enabled: true,
                            },
                        },
                        {
                            drawTime: "afterDatasetsDraw",
                            type: "line",
                            mode: "horizontal",
                            scaleID: "y-axis-0",
                            value: 72,
                            borderColor: "#ff0000",
                            borderWidth: 2,
                            label: {
                                backgroundColor: "#ff0000",
                                content: this.$t("level3"),
                                enabled: true,
                            },
                        },
                        {
                            drawTime: "afterDatasetsDraw",
                            type: "line",
                            mode: "horizontal",
                            scaleID: "y-axis-0",
                            value: 90,
                            borderColor: "#000000",
                            borderWidth: 2,
                            label: {
                                backgroundColor: "#000000",
                                content: "Error",
                                enabled: true,
                            },
                        },
                    ],
                },
            },
        };
    },
    methods: {
        fetchData() {
            let self = this;
            let date = this.$moment(self.selectedDate).format(
                "YYYY-MM-DD HH:mm"
            );
            //date = "2020-12-17 11:00";
            this.fetching = true;
            this.loaded = false;
            const requestOptions = {
                method: "GET",
                headers: authHeader(),
            };

            fetch(
                `${BACKEND_API}/api/pacientes/chart-avanzada-nueva/` +
                    this.$props.paciente +
                    `/` +
                    date,
                requestOptions
            )
                .then(handleResponse)
                .then((response) => {
                    self.fetching = false;
                    self.loaded = true;
                    self.datacollection["labels"] = response.labels;
                    self.datacollection["datasets"] = [
                        {
                            label: "Disconnected",
                            steppedLine: "before",
                            backgroundColor: "#ffdf00",
                            data: response.desconectado,
                        },
                        {
                            label: "Off Line",
                            steppedLine: "before",
                            backgroundColor: "#d9d9d9",
                            data: response.sin_cobertura,
                        },
                        {
                            label: "Moisture",
                            steppedLine: "before",
                            backgroundColor: "#9fa8da",
                            data: response.resistivo,
                        },
                    ];
                });
        },
    },
};
</script>

<style>
.instantcare-legend {
    color: black !important;
}

.height80 {
    margin-top: 20px;
    height: 80px;
}

.left {
    float: left;
}

.innerStartDate {
    background-color: black !important;
}

.vtimeselector {
    margin-top: 13px;
}

.vtimeselector__input {
    border: 0 !important;
    font-size: 14px;
}
</style>
